import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import tr from 'vuetify/es5/locale/tr'

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { tr },
    current: 'tr'
  },
})
